import { gql } from "@apollo/client";

export const GET_AUTO_TEMPLATES = gql`
  query GetAutoTemplates($isFavourite: Boolean, $teamUuid: String) {
    autoTemplates(isFavourite: $isFavourite, teamUuid: $teamUuid) {
      uuid
      name
      templateType
      description
      templateType
      isFavourite
      userPreferences
      createdAt
      updatedAt
      user {
        uuid
        firstName
        lastName
      }
    }
  }
`;

export const GET_AUTO_TEMPLATE_BY_UUID = gql`
  query GetAutoTemplate($uuid: UUID!) {
    autoTemplateById(uuid: $uuid) {
      uuid
      name
      description
      templateType
      isFavourite
      userPreferences
      createdAt
      updatedAt
      fields {
        uuid
        fieldName
        fieldIdx
        fieldValue
      }
      templatePreviews {
        previewContent
      }
    }
  }
`;
